import { QTableColumn } from 'pansx-utils';

export class AppUpdateVersion {
    public id?: number;
    public appVersionCode = 0;
    public isForce?: boolean;
    public appVersion = '';
    public appUrl = '';
    public updateInformation = '';
    public appSystem = '';

    public static of(o: unknown): AppUpdateVersion {
        return Object.assign(new AppUpdateVersion(), o);
    }
    public static getColumns(): QTableColumn[] {
        return [
            { name: 'id', field: 'id', label: '序号' },
            {
                name: 'appVersionCode',
                field: 'appVersionCode',
                label: '应用程序版本代码',
            },
            { name: 'isForce', field: 'isForce', label: '这就是力量' },
            { name: 'appVersion', field: 'appVersion', label: '应用程序版本' },
            { name: 'appUrl', field: 'appUrl', label: '应用程序url' },
            {
                name: 'updateInformation',
                field: 'updateInformation',
                label: '更新信息',
            },
        ];
    }
    public getColumnLabel(field: string) {
        const columns = AppUpdateVersion.getColumns();
        const find: QTableColumn | undefined = columns.find(
            (value) => value.field === field
        );
        if (typeof find !== 'undefined') {
            return find.label;
        }
        return '';
    }
}
